import React from 'react';
import { useParams, Link } from 'react-router-dom';
import './EssenceDetail.css';

const EssenceDetail = () => {
  const { id } = useParams();
  const essenceId = parseInt(id || '1');

  // Data source (can later be moved to API/data file)
  const essenceContent = {
    1: {
      name: 'Sjelsessens 1',
      location: 'Der halsen og haken møtes',
      gives: 'Relasjon til Universets Essens',
      description:
        'Sjelsessens 1 åpner din forbindelse til universets essens og kjerne.',
      detailedInfo:
        'Gjennom en dyp, sårbar og sterk relasjon løftes haken forsiktig og øynene blir myke. Herfra kan du være deg selv i kontakt med både det fysiske og det spirituelle.',
    },
    2: {
      name: 'Sjelsessens 2',
      location: 'Solar Plexus',
      gives: 'Relasjon til Sjelens Dans',
      description:
        'Sjelsessens 2 skaper en åpen tilstand i deg der du kan bevege deg sammen med din sjel.',
      detailedInfo:
        'I en vakker dans kan du være uten å bli påvirket av ytre energier. Herfra kan du danse sammen med andre du møter gjennom å være ditt eget lys.',
    },
    3: {
      name: 'Sjelsessens 3',
      location: 'Øverst på brystbenet',
      gives: 'Relasjon til Sjelens Lysstråler',
      description:
        'Sjelsessens 3 bringer deg inn til din sjels lysstråler.',
      detailedInfo:
        'Lysstrålene skaper en relasjon der fokuset lar hver lysstråle være unik, noe som også skaper naturlig smil. På denne måten kan du møte deg selv og andre gjennom ren glede og og følelsen av å bli sett.',
    },
    4: {
      name: 'Sjelsessens 4',
      location: '10 cm under navlen',
      gives: 'Relasjon til Sjelens Dyp',
      description:
        'Sjelsessens 4 binger deg til dypet av din egen sjel.',
      detailedInfo:
        'Ved å la kroppen få slappe av kan du åpne opp dine indre rom og være med dem. Her trengs det ingen analyse, kun ærlighet og å holde seg selv der man er. Herfra kan du møte deg selv og andre gjennom et dypt indre kosmos.',
    },
    5: {
      name: 'Sjelsessens 5',
      location: 'Toppen av hodet, fontanellen',
      gives: 'Relasjon til kosmisk helhet',
      description:
        'Sjelsessens 5 strekker seg som en spiral oppover og knytter seg til universets lysvev.',
      detailedInfo:
        'Gjennom denne forbindelsen oppnår du balanse samtidig som den kosmiske helheten blir en del av deg. Herfra kan du møte deg selv og andre gjennom å se bildet uten rammer.',
    },
    6: {
      name: 'Sjelsessens 6',
      location: 'Midt på brystbenet',
      gives: 'Relasjon til Hjertets Vibrasjoner',
      description:
        'Sjelsessens 6 åpner deg for hjertets vibrasjoner.',
      detailedInfo:
        'Ved å tillate nåtiden å få ta del i din reise vil hjertet skape lysvev der alt blir levende. Herfra kan du møte deg selv og andre gjennom spontanitet og dyp kjærlighet.',
    },
    7: {
      name: 'Sjelsessens 7',
      location: 'Pannen, det tredje øyet',
      gives: 'Relasjon til Kreativ Stillhet',
      description:
        'Sjelsessens 7 bringer den kreative stillheten til deg.',
      detailedInfo:
        'Gjennom et kreativt lysvev kan du møte stillheten som åpner for alt nytt. Grenser forsvinner og du kan møte deg selv og andre gjennom å gjøre det umulige mulig.',
    },
    8: {
      name: 'Sjelsessens 8',
      location: 'Nederst på ryggen, Sacrum',
      gives: 'Relasjon til Manifestert Tilstedeværelse',
      description:
        'Sjelsessens 8 bringer deg ned på jorden.',
      detailedInfo:
        'Når du lar deg manifestere som en sjel i en menneskekropp kan alt rundt deg få plass i din tilstedeværelse. Herfra kan du møte deg selv og andre i lysvevet som skaper kontakt med jorden.',
    },
    9: {
      name: 'Sjelsessens 9',
      location: 'Mellom skulderbladene',
      gives: 'Relasjon til Universets Puls',
      description:
        'Sjelsessens 9 bringer deg til lysvevet der alt er flytende.',
      detailedInfo:
        'Når du åpner for å puste i din sjels rytme skapes et rom av harmoni. Herfra kan du møte deg selv og andre gjennom å kunne holde universets puls i deg.',
    },
  };

  const fallback = {
    name: `Sjelsessens ${essenceId}`,
    location: 'Plassering kommer',
    gives: 'Relasjon kommer',
    description: 'Beskrivelse kommer snart.',
    detailedInfo:
      'Denne siden vil bli oppdatert med mer informasjon om denne sjelsessensen.',
  };

  const essenceData = { id: essenceId, ...(essenceContent[essenceId] || fallback) };

  return (
    <div className="essence-detail-page">
      {/* Hero Section */}
      <section className="essence-hero">
        <div className="hero-content">
          <div className="breadcrumb">
            <Link to="/about">Om Sjelsessensene</Link>
            <span> / </span>
            <span>{essenceData.name}</span>
          </div>
          <h1 className="essence-title">{essenceData.name}</h1>
          <p className="essence-subtitle">{essenceData.gives}</p>
        </div>
      </section>

      {/* Main Content */}
      <section className="essence-content">
        <div className="container">
          <div className="essence-info">
            <div className="info-card">
              <h3>Plassering</h3>
              <p>{essenceData.location}</p>
            </div>
            <div className="info-card">
              <h3>Gir</h3>
              <p>{essenceData.gives}</p>
            </div>
          </div>

          <div className="description-section">
            <h2>Om denne Sjelsessensen</h2>
            <p className="description">{essenceData.description}</p>
            <p className="detailed-info">{essenceData.detailedInfo}</p>
          </div>

          {/* Sections for Fordeler and Praktiser removed as requested */}

          <div className="navigation">
            <Link to="/about" className="back-button">
              ← Tilbake til alle Sjelsessensene
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default EssenceDetail;
